export default "__VITE_PUBLIC_ASSET__35b121f9__"